import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Grid } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '10vw',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 5,
};

export default function SavedModal(props) {

  return (
    <div>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        
      >
        
        <Box sx={style} alignContent='center' alignItems='center' justifyItems='center' justifyContent='center'>
        <Grid container justifyContent='center'>

          <Typography 
            id="modal-modal-description" 
            // alignContent='center' 
            textAlign='center'
            sx={{ mt: 2 }}>
              
            {props.text}
          </Typography>

          <Button onClick={props.handleClose} variant='outlined' className='save' style={{background: '#FFC904'}}>
              OK
          </Button>

        </Grid>  
        </Box>
      </Modal>
    </div>
  );
}
